import { createSlice } from '@reduxjs/toolkit';
import { getAdminDashboardSummary, getAdminDashboardTimeseries } from './adminDashboardActions';

const emptySummary = {
	usersTotal: 0,
	usersAdmins: 0,
	tutorsCount: 0,
	studentsCount: 0,
	adminProfilesCount: 0,
	tutorsPendingModeration: 0,
	appointmentsCompleted: 0,
	appointmentsPending: 0,
	appointmentsCanceled: 0,
	completedLessonsGmv: 0,
	platformFeesTotal: 0,
	totalWithdrawn: 0,
	pendingWithdrawalsCount: 0,
	pendingWithdrawalsAmount: 0,
};

const initialState = {
	loading: false,
	summary: { ...emptySummary },
	error: null,
	timeseriesLoading: false,
	timeseries: [],
	timeseriesError: null,
};

const adminDashboardSlice = createSlice({
	name: 'adminDashboard',
	initialState,
	reducers: {
		clearAdminDashboardError: (state) => {
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getAdminDashboardSummary.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(getAdminDashboardSummary.fulfilled, (state, action) => {
				state.loading = false;
				state.summary = { ...emptySummary, ...action.payload };
				state.error = null;
			})
			.addCase(getAdminDashboardSummary.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload?.error ?? 'Failed to load dashboard';
			})
			.addCase(getAdminDashboardTimeseries.pending, (state) => {
				state.timeseriesLoading = true;
				state.timeseriesError = null;
			})
			.addCase(getAdminDashboardTimeseries.fulfilled, (state, action) => {
				state.timeseriesLoading = false;
				state.timeseries = Array.isArray(action.payload?.points) ? action.payload.points : [];
				state.timeseriesError = null;
			})
			.addCase(getAdminDashboardTimeseries.rejected, (state, action) => {
				state.timeseriesLoading = false;
				state.timeseriesError = action.payload?.error ?? 'Failed to load trends';
			});
	},
});

export const { clearAdminDashboardError } = adminDashboardSlice.actions;
export default adminDashboardSlice.reducer;
